import { Form } from '@ant-design/compatible';
import { Checkbox, Typography } from 'antd';
import React from 'react';

import PhoneNumberField from '../../../components/PhoneNumberField';
import { MessageMethod } from '../../../graphql/api/generated';
import { PermissionKey_enum } from '../../../graphql/hasura/generated';
import { authentication } from '../../../stores';
import { FormItem, TextField } from '../../ModelForm/form-fields';

import { IRegisteredUserFormMergedProps } from './formik';

export const NewUserSection: React.FC<IRegisteredUserFormMergedProps> = (props) => {
  const { values, setFieldValue, handleChange, isSubmitting, UserModel } = props;
  const canSendInvitation = authentication.hasPermission(PermissionKey_enum.User_SendMessage);

  const getFieldConfig = (fieldName: string) => {
    const introspectionField = UserModel.introspection.getField(fieldName);
    const formOptions = UserModel.formOptions?.fields.find(f => f.fieldName === fieldName);

    return { introspectionField, formOptions };
  };

  const firstNameField = getFieldConfig('firstName');
  const lastNameField = getFieldConfig('lastName');
  const phoneNumberField = getFieldConfig('phoneNumber');
  const emailField = getFieldConfig('email');

  return (
    <>
      <Typography.Paragraph style={{ paddingBottom: 20 }}>
        Please provide a name, phone number, and email that will be used to sign in to Chirp.
      </Typography.Paragraph>

      <TextField
        {...props}
        required
        isNew
        field={firstNameField.introspectionField}
        maxLength={firstNameField.formOptions?.maxLength}
      />

      <TextField
        {...props}
        required
        isNew
        field={lastNameField.introspectionField}
        maxLength={lastNameField.formOptions?.maxLength}
      />

      <FormItem
        {...props}
        isNew
        field={phoneNumberField.introspectionField}
        help={<p className='help-text'>Phone number or email address must be provided</p>}
      >
        <PhoneNumberField
          value={values.phoneNumber}
          onChange={(value) => {
            setFieldValue('phoneNumber', value);

            if (!value && values.messageMethod === MessageMethod.SMS) {
              setFieldValue('messageMethod', null);
            }
          }}
          disabled={props.isSubmitting}
        />
      </FormItem>

      <TextField
        {...props}
        handleChange={(e: React.ChangeEvent<any>) => {
          handleChange(e);

          if (!e.target.value && values.messageMethod === MessageMethod.EMAIL) {
            setFieldValue('messageMethod', null);
          }
        }}
        isNew
        field={emailField.introspectionField}
        maxLength={emailField.formOptions?.maxLength}
        style={{ marginBottom: 20 }}
      />

      {canSendInvitation && (
        <Form.Item wrapperCol={{ offset: 7 }}>
          <div>Optionally send the user a link to download the Chirp Access App:</div>
          <Checkbox
            checked={values.messageMethod === MessageMethod.SMS}
            disabled={isSubmitting || !values.phoneNumber}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue('messageMethod', MessageMethod.SMS);
              } else {
                setFieldValue('messageMethod', null);
              }
            }}
          >
            Text Message
          </Checkbox>
          <Checkbox
            checked={values.messageMethod === MessageMethod.EMAIL}
            disabled={isSubmitting || !values.email}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue('messageMethod', MessageMethod.EMAIL);
              } else {
                setFieldValue('messageMethod', null);
              }
            }}
          >
            Email
          </Checkbox>
        </Form.Item>
      )}
    </>
  );
};
